import { gsap } from 'gsap';

export default function quoteSlider() {
	const qslider = $('.qSlider__slider');
	const qsliderSettings = {
		dots: true,
		autoplay: true,
		autoplaySpeed: 9000,
		speed: 2000,
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		touchMove: true,
		arrows: false,
		accessibility: true,
		infinite: true,
		cssEase: 'linear(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1)',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					dots: false,
					swipe: true,
				},
			},
		],
	};

	if (qslider) {
		qslider.slick(qsliderSettings);
	}

	const fullSlider = $('.fullSlider__slider');
	const fullSliderSettings = {
		dots: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		pauseOnHover: true,
		touchMove: true,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		accessibility: true,
		cssEase: 'ease-in-out',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					dots: false,
					swipe: true,
				},
			},
		],
	};

	if (fullSlider) {
		fullSlider.slick(fullSliderSettings);
	}

	$(window).on('load resize', function () {
		if (fullSlider) {
			fullSlider.slick('setPosition');
			let startHeight = fullSlider
				.find('.slick-slide[data-slick-index=0]')
				.find('img')
				.height();
			let startDots = startHeight - 45;
			let slickDots = $('.fullSlider__slider .slick-dots');
			slickDots.css('top', startDots + 'px');
		}
		if (qslider) {
			qslider.slick('setPosition');
			let startHeight = qslider
				.find('.slick-slide[data-slick-index=0]')
				.height();
			let dotHeight = startHeight - 45;
			let slickDots = $('.qSlider__slider .slick-dots');
			slickDots.css('top', dotHeight + 'px');
		}
	});

	qslider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		let slideCh = new gsap.timeline();
		slideCh
			.fromTo(
				$('.spText'),
				{ opacity: 1 },
				{ opacity: 0, ease: 'power4.out', duration: 1.5 }
			)
			.fromTo(
				$('.qslider__q'),
				{ opacity: 1 },
				{ opacity: 0, ease: 'power4.out', duration: 1.5 },
				'-=1.5'
			);
	});

	qslider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
		let slideCh = new gsap.timeline();
		slideCh
			.fromTo(
				$('.spText'),
				{ opacity: 0 },
				{ opacity: 1, ease: 'power4.out', duration: 3, delay: 1 }
			)
			.fromTo(
				$('.qslider__q'),
				{ opacity: 0 },
				{ opacity: 1, ease: 'power4.out', duration: 2 },
				'-=3'
			);
	});
}
